import React, { memo } from 'react';
import cls from './DaysModeStage.module.css';
import classNames from 'classnames';
import moment from 'moment';
import { Day } from './DayItem';
import { DaysModeStageChild } from './DaysModeStageChild/DaysModeStageChild';
import { useSelector } from 'react-redux';

export const DaysModeStage = memo(({ stage }) => {
    const { days, opensStages } = useSelector((state) => state.gantReducer);
    if (!stage.positions.length) return null;

    const currentMonths = +moment(stage.planned.start_date).locale('ru').format('MM');
    const currentDay = +moment(stage.planned.start_date).locale('ru').format('DD');

    let isPlanFactShow = true;

    if (isPlanFact) {
        isPlanFactShow = isPlanFact && !!stage.planned.start_date;
    }

    if (!isPlanFactShow) {
        return null;
    }

    return (
        <div className={classNames(cls.DaysModeStage)}>
            <div className={classNames(cls.days)}>
                {days.map((month, index) => (
                    <Day
                        month={month}
                        stage={stage}
                        isPlanFact={isPlanFact}
                        currentDay={currentDay}
                        currentMonths={currentMonths}
                        key={index}
                    />
                ))}
            </div>
            {opensStages[stage.id] && (
                <>
                    {stage.positions.map((positionGuid) => (
                        <DaysModeStageChild key={positionGuid} childGuid={positionGuid} />
                    ))}
                </>
            )}
        </div>
    );
});
